import {
  AppleFruit,
  Child,
  IconProps,
  NoSmoking,
  Target,
  Umbrella,
  UsersChat,
} from 'icons';
import { rem } from 'polished';
import React from 'react';
import { useTheme } from 'styled-components';

export const BookIcon = ({
  icon,
  width = 24,
  height = 24,
  ...iconProps
}: { icon: string | null; width?: number; height?: number } & IconProps) => {
  const { colors } = useTheme();

  if (!icon) return null;

  const props = {
    width: rem(width),
    height: rem(height),
    'aria-hidden': true,
    primaryColor: colors.border.primary,
    ...iconProps,
  } as IconProps;

  switch (icon) {
    case 'practical-support':
      return <Umbrella {...props} />;
    case 'counselling':
      return <UsersChat {...props} />;
    case 'life-coaching':
      return <Target {...props} />;
    case 'wellness-coaching':
      return <AppleFruit {...props} />;
    case 'tobacco-cessation':
      return <NoSmoking {...props} />;
    case 'pediatric-care':
      return <Child {...props} />;
    default:
      return null;
  }
};
